import { useState } from 'react'

export type UseLocalStorageReturn<T = Record<string, string>> = [
  T,
  (value: T) => void
]

export const useLocalStorage = <T = Record<string, string>>(
  name: string,
  defaultValue: T
): UseLocalStorageReturn<T> => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(name)

      if (!item) {
        throw new Error('Is new user!')
      }

      return JSON.parse(item)
    } catch (error) {
      return defaultValue
    }
  })

  const set = (value: T) => {
    setStoredValue(value)
    window.localStorage.setItem(name, JSON.stringify(value))
    return value
  }

  return [storedValue, set]
}
